import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { fetchAuthUrl } from "app/services/cognito/cognito.service";
import LoadingSpinner from "components/LoadingSpinner";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";

const WearableView = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(setTitle({ title: "CardioOneConnect Preview" }));
  }, [dispatch]);

  const redirectingToWearables = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await fetchAuthUrl("Rhythm");

      const url = response?.data?.url;

      if (!url) {
        throw new Error("Failed to redirect to CardioOneConnect platform");
      }

      window.location.replace(url);
    } catch (err) {
      const errorMessage =
        err?.message || "Failed to redirect to CardioOneConnect platform";
      setError(errorMessage);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    redirectingToWearables();
  }, [redirectingToWearables]);

  if (error) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        px={2}
      >
        <Box textAlign="center">
          <Typography variant="h6" color="error" mb={1}>
            Error
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {error}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={2}
    >
      <Box textAlign="center">
        {isLoading && <LoadingSpinner />}
        <Typography variant="h6" fontWeight={500} mb={1}>
          Redirecting...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please wait while we redirect you to the CardioOneConnect platform.
        </Typography>
      </Box>
    </Box>
  );
};

export default WearableView;
